import stickybits from 'stickybits'

var _stickybitInstance = null
var _stickybitEl = null
var _stickybitOptions = null
var _minWidthToEnable = 0

function setStickybitsElement(el) {
  _stickybitEl = el
}
function setStickybitsVariables({ minWidth, options }) {
  _minWidthToEnable = minWidth
  _stickybitOptions = options
}

function updateStickybitInstance() {
  if (window.innerWidth >= _minWidthToEnable) {
    if (!_stickybitInstance) {
      _stickybitInstance = stickybits(_stickybitEl, _stickybitOptions)
    }
  } else if (_stickybitInstance) {
    _stickybitInstance.cleanup()
    _stickybitInstance = null
  }
}

export default {
  inserted: (el, binding) => {
    setStickybitsElement(el)
    setStickybitsVariables(binding.value)
    updateStickybitInstance()
    window.addEventListener('resize', updateStickybitInstance)
  },
  update: (el, binding) => {
    setStickybitsVariables(binding.value)
    updateStickybitInstance()
  },
  unbind: el => {
    if (_stickybitInstance) {
      _stickybitInstance.cleanup()
    }
    window.removeEventListener('resize', updateStickybitInstance)
  }
}
